module.exports = __webpack_public_path__ + "static/img/首页方案4.faf9aa1e.png";